import { ApiService } from '../../services/ApiService';

export const actions = {
    fetchMedia(context) {
        return ApiService.get(`/media`).then(response => {
            context.commit('setMedia', response.data)
        });
    },
};